/**
 * Kitchen-Bridge fallback for ESC/POS thermal printing.
 *
 * When configured, the frontend tries POSTing the label payload to a tiny
 * local-network bridge (e.g. http://localhost:9101/print) BEFORE falling
 * back to the cloud `/api/labels/{id}/print-thermal` route. This keeps
 * label printing alive when WAN is down (mining-camp use case).
 *
 * The bridge URL is stored in localStorage so each kitchen device can be
 * paired to its on-prem printer once and stay there.
 *
 * A reference Node bridge implementation lives at
 *   /app/kitchen-bridge/server.js
 * and runs on the same LAN as the printer.
 */
const KEY = "haccp-kitchen-bridge-url";

export function getBridgeUrl() {
  return localStorage.getItem(KEY) || "";
}
export function setBridgeUrl(url) {
  if (url) localStorage.setItem(KEY, url);
  else localStorage.removeItem(KEY);
}

export async function tryBridgePrint({ label, site, copies = 1 }) {
  const url = getBridgeUrl();
  if (!url) return { ok: false, reason: "no-bridge" };
  try {
    const res = await fetch(`${url.replace(/\/$/, "")}/print`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        label,
        site_name: site?.name || "",
        printer_host: site?.printer_host || "",
        printer_port: site?.printer_port || 9100,
        copies,
      }),
      // bridge is on LAN; keep timeout tight so we fall through fast when offline
      signal: AbortSignal.timeout ? AbortSignal.timeout(2500) : undefined,
    });
    if (!res.ok) return { ok: false, reason: `bridge-${res.status}` };
    return { ok: true };
  } catch (e) {
    return { ok: false, reason: e?.name || "network" };
  }
}
